import { AppForm } from '../../../../../../common/forms/app.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../openapi';
import { FormControl, Validators } from '@angular/forms';

export class ApplicantCorrespondenceForm extends AppForm {
  constructor() {
    super({
      correspondenceCountry: new FormControl(null, Validators.maxLength(255)),
      correspondenceVoivodeship: new FormControl(null, Validators.maxLength(255)),
      correspondenceCounty: new FormControl(null, Validators.maxLength(255)),
      correspondenceMunicipality: new FormControl(null, Validators.maxLength(255)),
      correspondencePostalCode: new FormControl(null, [Validators.maxLength(255), Validators.required]),
      correspondencePostOffice: new FormControl(null, [Validators.maxLength(255), Validators.required]),
      correspondenceCity: new FormControl(null, [Validators.maxLength(255), Validators.required]),
      correspondenceHouseNumber: new FormControl(null, [Validators.maxLength(255), Validators.required]),
      correspondenceApartmentNumber: new FormControl(null, [Validators.maxLength(255)]),
      correspondenceStreet: new FormControl(null, [Validators.maxLength(255)]),
    });
  }

  public toWriteModel(): Partial<ApplicantAppEntityApplicantWrite> {
    return {
      ...this.value
    };
  }
}
